import actionCreatorFactory from "typescript-fsa";
import { ModalDataItem } from "./types";

const actionCreator = actionCreatorFactory("@@App");

export const appActions = {
    showLoading: actionCreator("SHOW_LOADING"),
    hideLoading: actionCreator("HIDE_LOADING"),
    showModal: actionCreator.async<ModalDataItem, {}>("SHOW_MODAL"),
    closeModal: actionCreator("CLOSE_MODAL"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}